var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vericode_wrap_"},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([_vm.field, {
    rules: [{
      required: true,
      message: '请输入验证码'
    }]
}]),expression:"[field, {\n    rules: [{\n      required: true,\n      message: '请输入验证码'\n    }]\n}]"}],attrs:{"size":_vm.size,"aria-placeholder":"请输入验证码","placeholder":"请输入验证码"},on:{"blur":_vm.handleInput}}),_c('a-button',{staticClass:"mrg_l8_ btn_send_code_",attrs:{"size":_vm.size,"type":"primary","ghost":""},on:{"click":_vm.handleSendCode}},[_vm._v(_vm._s(_vm.count > 0 ? _vm.count + 's' : '发送验证码'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }